import { apply, put, select } from 'redux-saga/effects';
import jsPDF from 'jspdf';
import FileSaver from 'file-saver';
import {
  onLoadCoursesSucceeded,
  onLoadCourseSucceeded,
  onLoadCourseFailed,
  onLoadCardSucceeded,
  onLoadCardFailed,
  onSearchSucceeded,
  getPinnedContentSuccessAction,
  loadDefaultBulletinBoardSucceeded,
  pinOrUnpinContentSuccessAction,
  loadCardsForBulletinBoardSuccessAction,
  loadCardByIdErrorAction,
  loadCardByIdSuccessAction,
} from '../reducers/course.reducers';

import { errorNotification, successNotification } from '../reducers/notification.reducers';

export function* loadCourses(courseApi) {
  const response = yield apply(courseApi, courseApi.loadCoursesAndGroups);
  if (response.errorCode) {
    yield put(errorNotification('Fehler beim Laden der Kurse'));
  } else {
    yield put(onLoadCoursesSucceeded({ courses: response }));
  }
}

export function* sendRunAction(courseApi, { payload }) {
  try {
    const courseRunDto = {
      startDate: yield select(state => state.courses.courseRunStartedAt),
      cardId: payload.card.id,
      action: payload.type,
    };

    const response = yield apply(
      courseApi,
      courseApi.sendRunAction, [courseRunDto]);
  } catch (e) {
    console.log(e);
  }
}

export function* finishRun(courseApi) {
  try {
    const courseFinishedDto = {
      startDate: yield select(state => state.courses.courseRunStartedAt),
      courseId: yield select(state => state.courses.selectedCourseId),
    };

    const response = yield apply(
      courseApi,
      courseApi.finishRun, [courseFinishedDto]);

    yield loadCourses(courseApi);
  } catch (e) {
    console.log(e);
  }
}

export function* resetProgress(courseApi) {
  try {
    const courseId = yield select(state => state.courses.selectedCourseId);

    const response = yield apply(
      courseApi,
      courseApi.resetProgress, [courseId]);
  } catch (e) {
    console.log(e);
  }
}

export function* search(courseApi, { payload }) {
  const searchDto = {
    searchTerm: payload,
  };

  try {
    const response = yield apply(
      courseApi,
      courseApi.search, [searchDto],
    );

    if (response.errorCode) {
      yield put(errorNotification('Fehler bei der Suche'));
    } else {
      yield put(onSearchSucceeded(response));
    }
  } catch (e) {
    console.log(e);
  }
}

export function* loadCourseCards(courseApi, { payload }) {
  try {
    const response = yield apply(
      courseApi,
      courseApi.loadCards, [payload.id]);

    if (response.error) {
      yield put(onLoadCourseFailed({
        message: response.message || 'Fehler beim Abrufen der Kurse',
      }));
    } else {
      yield put(onLoadCourseSucceeded({
        cards: response,
        course: payload,
        includeAll: payload.includeAll,
      }));
    }
  } catch (e) {
    yield put(onLoadCourseFailed({
      message: 'Fehler beim Abrufen der Kurse',
    }));
  }
}

export function* loadCourseCard(courseApi, { payload }) {
  try {
    const response = yield apply(
      courseApi,
      courseApi.loadCardbyID, [payload.cardId]);

    if (response.error) {
      yield put(onLoadCardFailed({
        message: response.message || 'Fehler beim Abrufen des Kärtchens',
      }));
    } else {
      yield put(onLoadCardSucceeded({ card: response }));
    }
  } catch (e) {
    yield put(onLoadCardFailed({
      message: 'Fehler beim Abrufen des Kärtchens',
    }));
  }
}

export function* exportPdf(courseApi, { payload }) {
  yield put(successNotification('Der Download startet in Kürze'));
  const state = yield select();
  const token = state.authentication.accessToken;
  const urlParams = {
    url: encodeURIComponent(payload),
    token,
  };

  try {
    const response = yield apply(
        courseApi,
        courseApi.generatePdf, [urlParams]);

    if (response.error) {
      yield put(errorNotification('Fehler beim Exportieren'));
    }

    FileSaver.saveAs(response, 'export.pdf');
  } catch (e) {
    yield put(errorNotification('Fehler beim Exportieren'));
  }
}

export function* loadDefaultBulletinBoard(courseApi) {
  try {
    const response = yield apply(
      courseApi,
      courseApi.getDefaultBulletinBoard);


    if (response.error || !response) {
      // handle error
    } else {
      yield put(loadDefaultBulletinBoardSucceeded(response));
    }
  } catch (e) {

  }
}

export function* getPinnedContent(courseApi, { payload }) {
  try {
    const { boardId, sortFilterDto } = payload;

    const response = yield apply(
      courseApi,
      courseApi.getPinnedContent, [boardId, sortFilterDto],
    );

    if (response.error) {

    } else {
      yield put(getPinnedContentSuccessAction(response));
    }
  } catch (e) {

  }
}

export function* pinOrUnpinContent(courseApi, { payload }) {
  const { bulletinBoardId, pinningDto } = payload;

  try {
    const response = yield apply(
      courseApi,
      courseApi.pinOrUnpinItem, [bulletinBoardId, pinningDto],
    );

    if (response.error) {
    } else {
      // yield put(getPinnedContentAction({boardId: bulletinBoardId, sortFilterDto:{}}))
      // yield put(loadCardsForBoardAction({boardId: bulletinBoardId, sortFilterDto:{}}))
      yield put(pinOrUnpinContentSuccessAction(pinningDto));
    }
  } catch (e) {
  }
}

export function* getCardsForBulletinBoard(courseApi, { payload }) {
  try {
    const { boardId, sortFilterDto } = payload;

    const response = yield apply(
      courseApi,
      courseApi.getCardsByIds, [boardId, sortFilterDto],
    );

    if (response.error || !Array.isArray(response)) {

    } else {
      yield put(loadCardsForBulletinBoardSuccessAction(response));
    }
  } catch (e) {

  }
}



// WEBPACK FOOTER //
// ./src/app/sagas/course.sagas.js